module.exports = __webpack_public_path__ + "img/human.2599a21e.svg";